// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import classnames from 'classnames'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import { updateScheme } from '../../state/actions'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** Footer */
const Footer = ({ scheme, updateScheme }) => {
  const thisYear = new Date().getFullYear()

  return (
    <footer>
      <p>Auroville Archives © {thisYear}</p>
      <div>
        <a
          href="#"
          style={{ background: '#0d314e' }}
          className={classnames({
            active: scheme === 'd1',
          })}
          title="Default Scheme"
          onClick={(e) => {
            e.preventDefault()
            updateScheme('d1')
          }}
        />
        <a
          href="#"
          style={{ background: 'var(--gray-8)' }}
          className={classnames({
            active: scheme === 'd2',
          })}
          title="Default Scheme"
          onClick={(e) => {
            e.preventDefault()
            updateScheme('d2')
          }}
        />
        <a
          href="#"
          style={{ background: 'var(--gray-9)' }}
          className={classnames({
            active: scheme === 'd3',
          })}
          title="Default Scheme"
          onClick={(e) => {
            e.preventDefault()
            updateScheme('d3')
          }}
        />
      </div>
    </footer>
  )
}

// ----------------------------------------------------------------------------
// ---------------------------------------------------------------------- State
// ----------------------------------------------------------------------------
const withState = connect(
  (state) => ({
    scheme: state.scheme,
  }),
  (dispatch) => ({
    updateScheme(payload) {
      dispatch(updateScheme(payload))
    },
  })
)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Compose
// ----------------------------------------------------------------------------
/** Compose ala FP style */
const ComposedFooter = compose(
  withState // Add state
)(Footer)

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default ComposedFooter
